import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class CarouselSwipeApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.CarouselSwipeInteraction;

  constructor(private eventType: string, private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      type: this.eventType,
      label: this.label
    };
  }
}
